module.exports = __webpack_public_path__ + "img/dominique.521fe7e1.jpg";